export default __webpack_public_path__ + "static/media/cfp.aab1d6e3.png";